import Image from 'next/image';
import React from 'react';
import FadeInAnimation from "../Common/FadeInAnimation";
import { useTranslations } from '../../locales/useTranslations';

const KarriereHeader = () => {
    const { t } = useTranslations();

    return (
        <div className="mainbanner karriere-header">
            {/* Subtile Hintergrund-Elemente */}
            <div className="karriere-header__decoration karriere-header__decoration--top-right" />
            <div className="karriere-header__decoration karriere-header__decoration--bottom-left" />

            <section className="services-area ptb-100 karriere-header__content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="services-content it-service-content">
                                <div className="content">
                                    <div className="karriere-header__badge">
                                        {t('career_header_upperTitle')}
                                    </div>

                                    <h1 className="karriere-header__title">
                                        {t('career_header_title')}
                                    </h1>

                                    <p className="karriere-header__description">
                                        {t('career_header_description')}
                                    </p>

                                    <a href="#jobs" className="karriere-header__cta">
                                        {t('career_header_cta')}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <div className="services-image">
                                <FadeInAnimation direction="right" delay={100}>
                                    <div className="karriere-header__image-wrapper">
                                        <Image
                                            src="/images/karriere/header.webp"
                                            alt="simplify data - Karriere Team"
                                            width={400}
                                            height={300}
                                            className="karriere-header__image"
                                        />
                                    </div>
                                </FadeInAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default KarriereHeader;
